var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditorToolbarTextTypeA2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 19H14L9 5H7L2 19H4L5.43 15H10.57L12 19ZM6.14 13L8 7.8L9.86 13H6.14Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2499 19.16V17.61L18.8699 14.26C19.1765 13.96 19.4365 13.69 19.6499 13.45C19.8409 13.2395 20.0024 13.004 20.1299 12.75C20.2393 12.5153 20.294 12.2589 20.2899 12C20.2963 11.7297 20.227 11.463 20.0899 11.23C19.9544 11.0111 19.7605 10.8344 19.5299 10.72C19.2792 10.6044 19.0059 10.5463 18.7299 10.55C18.4479 10.5417 18.1687 10.6072 17.9199 10.74C17.685 10.8552 17.495 11.0451 17.3799 11.28C17.2446 11.5387 17.1792 11.8282 17.1899 12.12H15.1899C15.1755 11.5095 15.3313 10.907 15.6399 10.38C15.9413 9.88532 16.3835 9.49186 16.9099 9.25C17.4959 8.96829 18.1398 8.82787 18.7899 8.84C19.4446 8.82465 20.0942 8.958 20.6899 9.23C21.2014 9.46177 21.6404 9.82815 21.9599 10.29C22.2626 10.757 22.4192 11.3036 22.4099 11.86C22.4083 12.2514 22.3302 12.6386 22.1799 13C21.9826 13.4572 21.7124 13.8794 21.3799 14.25C20.8769 14.8321 20.3357 15.38 19.7599 15.89L18.2499 17.33V17.4H22.5199V19.16H15.2499Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditorToolbarTextTypeA2);
export default __webpack_public_path__ + "static/media/editor_toolbar_text_type_a2.67f775854418a33a745313c408635b4e.svg";
export { ForwardRef as ReactComponent };